'use client'

import useEnquiry from '@hooks/useEnquiry'
import { agentDataLayer } from '@plugin/google/gtm/modules/agent'
import { get, map } from 'lodash-es'
import { useCallback } from 'react'

export default function AgentInfoContactContent({
  data,
  agent
}) {

  const { showAgentEnquiry } = useEnquiry()
  const requestHandle = useCallback((event, item) => {
    agentDataLayer.requestClick(get(item, 'value', ''))
    showAgentEnquiry({ agent, spec: item })(event)
  }, [showAgentEnquiry, agent])

  return (
    <ul className='border rounded-sm'>
      {
        map(data, item => (
          <div key={item.value} className='flex items-center justify-between h-42 px-12 text-sm leading-16 border-t first:border-t-0 even:bg-neutral-1'>
            <span className='flex-1'>{item.label}</span>
            <span className='button-text-primary' onClick={(event) => requestHandle(event, item)}>Request</span>
          </div>
        ))
      }
    </ul>
  )
}